/* 
    konstanta province
*/
export const FETCH_PROVINCE_LIST = "FETCH_PROVINCE_LIST";
export const FETCH_PROVINCE_LIST_SUCCESS = "FETCH_PROVINCE_LIST_SUCCESS";
export const SELECTED_PROVINCE = "SELECTED_PROVINCE";

/* 
    konstanta city
*/
export const FETCH_CITY_LIST = "FETCH_CITY_LIST";
export const FETCH_CITY_LIST_SUCCESS = "FETCH_CITY_LIST_SUCCESS";
export const SELECTED_CITY = "SELECTED_CITY";
/* 
    konstanta district
*/
export const FETCH_DISTRICT_LIST = "FETCH_DISTRICT_LIST";
export const FETCH_DISTRICT_LIST_SUCCESS = "FETCH_DISTRICT_LIST_SUCCESS";
export const SELECTED_DISTRICT = "SELECTED_DISTRICT";

/* 
    konstanta store
*/
export const FETCH_STORE_LIST = "FETCH_STORE_LIST";
export const FETCH_STORE_LIST_SUCCESS = "FETCH_STORE_LIST_SUCCESS";
export const FETCH_DETAIL_STORE = "FETCH_DETAIL_STORE";
export const FETCH_DETAIL_STORE_SUCCESS = "FETCH_DETAIL_STORE_SUCCESS";

/* 
filter
*/

export const SET_FILTER_VALUE = "SET_FILTER_VALUE";
export const SET_SEARCH_VALUE = "SET_SEARCH_VALUE";
export const SET_OPTION_VALUE = "SET_OPTION_VALUE";
export const SET_NEXT_VALUE   = "SET_NEXT_VALUE";

/* 
notification
*/

export const FETCH_NOTIFICATION_LIST = "FETCH_NOTIFICATION_LIST";
export const FETCH_NOTIFICATION_LIST_SUCCESS = "FETCH_NOTIFICATION_LIST_SUCCESS";

/* 
orders
*/

export const FETCH_ORDER_LIST = "FETCH_ORDER_LIST";
export const FETCH_ORDER_LIST_SUCCESS = "FETCH_ORDER_LIST_SUCCESS";
export const FETCH_MALL_LIST = "FETCH_MALL_LIST";
export const FETCH_MALL_LIST_SUCCESS = "FETCH_MALL_LIST_SUCCESS";

/* 
negotiation
*/
export const FETCH_NEGOTIATION_LIST = "FETCH_NEGOTIATION_LIST";
export const FETCH_NEGOTIATION_LIST_SUCCESS = "FETCH_NEGOTIATION_LIST_SUCCESS";

/* 
compare
*/
export const FETCH_COMPARE_LIST = "FETCH_COMPARE_LIST";
export const FETCH_COMPARE_LIST_SUCCESS = "FETCH_COMPARE_LIST_SUCCESS";

/* 
cart
*/
export const FETCH_CART_LIST = "FETCH_CART_LIST";
export const FETCH_CART_LIST_SUCCESS = "FETCH_CART_LIST_SUCCESS";

/* 
compare detail
*/
export const FETCH_COMPARE_DETAIL = "FETCH_COMPARE_DETAIL";
export const FETCH_COMPARE_DETAIL_SUCCESS = "FETCH_COMPARE_DETAIL_SUCCESS";
/* 
comparison report
*/
export const FETCH_COMPARISON_REPORT = "FETCH_COMPARISON_REPORT";
export const FETCH_COMPARISON_REPORT_SUCCESS = "FETCH_COMPARISON_REPORT_SUCCESS";

/* 
complaint
*/
export const FETCH_COMPLAINT_LIST = "FETCH_COMPLAINT_LIST";
export const FETCH_COMPLAINT_LIST_SUCCESS = "FETCH_COMPLAINT_LIST_SUCCESS";

/* 
transaction detail
*/
export const FETCH_ORDER_DETAIL = "FETCH_ORDER_DETAIL ";
export const FETCH_ORDER_DETAIL_SUCCESS = "FETCH_ORDER_DETAIL_SUCCESS";
/* 
negotiation detail
*/
export const FETCH_NEGOTIATION_DETAIL = "FETCH_NEGOTIATION_DETAIL ";
export const FETCH_NEGOTIATION_DETAIL_SUCCESS = "FETCH_NEGOTIATION_DETAIL_SUCCESS";
